/* eslint-disable max-len */
import FulfillmentSettingsRoot from '@/components/pages/Root.vue';
import { FourOhFour } from 'shipbob_design_system';
import { ENV } from '@/env';

const FulfillmentSettingsPageContainer = 
  () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/components/pages/FulfillmentSettings/FulfillmentSettings.vue');

const PackagingSlipConfigurationPageContainer = () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/components/pages/PackagingSlipConfiguration/PackagingSlipConfiguration.vue');

const PackagingSlipPage = () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/components/pages/PackingSlip/PackingSlip.vue');

const fulfillmentSettingsRoutes = [
  {
    path: ENV.MFE_ROOT_ROUTE,
    name: 'FulfillmentSettings.Root',
    meta: {
      requiresAuth: true,
    },
    component: FulfillmentSettingsRoot,
    children: [
      // base route
      {
        path: '',
        name: 'FulfillmentSettings',
        meta: {
          requiresAuth: true,
          telemetry: {
            name: 'FulfillmentSettings',
          },
        },
        component: FulfillmentSettingsPageContainer,
      },
      // other application routes
      {
        path: 'packaging-slip',
        name: 'FulfillmentSettings.PackagingSlipConfiguration',
        meta: {
          requiresAuth: true,
          showSideNav: true,
        },
        component: PackagingSlipConfigurationPageContainer,
      },
      {
        path: 'packaging-slip/customize',
        name: 'FulfillmentSettings.Customize',
        meta: {
          requiresAuth: true,
          showSideNav: true,
        },
        component: PackagingSlipPage,
      },
      {
        path: 'customization-suite',
        alias: 'custom-order-documents',
        name: 'CustomizationSuite',
        meta: {
          requiresAuth: true,
          showSideNav: true,
        },
        component: () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/features/custom-order-documents/views/Root.vue'),
        children: [
          {
            path: '',
            name: 'CustomOrderDocumentsMain',
            component: () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/features/custom-order-documents/views/Main.vue'),
          },
          {
            path: 'gift-notes',
            component: () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/features/custom-order-documents/views/GiftNotes.vue'),
          },
          {
            path: 'marketing-inserts',
            component: () => import(/* webpackChunkName: "fulfillment-settings-page" */ '@/features/custom-order-documents/views/MarketingInserts.vue'),
          },
        ],
      },
      // 404
      {
        path: '404',
        name: 'FulfillmentSettings.404',
        meta: {
          requiresAuth: false,
        },
        component: FourOhFour,
      },
    ],
  },
  {
    path: `${ENV.MFE_ROOT_ROUTE}:afterFulfillmentSettings(.*)`,
    meta: {
      requiresAuth: false,
    },
    redirect: { name: 'FulfillmentSettings.404' },
  },
];

export { fulfillmentSettingsRoutes };
